/* Ayudate · Catálogo de áreas y cursos */

/* Los cursos de ciencias llevan código oficial del plan de estudios.
   Los idiomas van sin código: su identificador es el nombre con el nivel.

   Las cuatro áreas del Tec que abren el archivo (Matemática, Física, Química
   y Biología, Ingeniería en Computación) van escritas a mano: son las de más
   tránsito, las comparte media universidad y cada una arrastra su color
   histórico, que es el que le acompaña al tutor por toda la interfaz. Las
   demás carreras del Tec vienen enteras de datos/cursosTEC.js. */

import { AREAS_TEC, AREAS_TEC_IDS } from "./cursosTEC";
import { AREAS_UCR, AREAS_UCR_IDS } from "./cursosUCR";

export const AREAS = [
  {
    id: "mate", nombre: "Matemática", grupo: "Ciencias Básicas", color: "#14B8A6",
    cursos: [
      { cod: "MA0101", nom: "Matemática General" },
      { cod: "MA1102", nom: "Cálculo Diferencial e Integral" },
      { cod: "MA1103", nom: "Cálculo y Álgebra Lineal" },
      { cod: "MA1304", nom: "Cálculo para Administración" },
      { cod: "MA1403", nom: "Matemática Discreta" },
      { cod: "MA2104", nom: "Cálculo Superior" },
      { cod: "MA2105", nom: "Ecuaciones Diferenciales" },
      { cod: "PI2610", nom: "Probabilidad y Estadística I" },
      { cod: "PI3612", nom: "Probabilidad y Estadística II" },
      { cod: "CM3207", nom: "Métodos Numéricos" }],
  },
  {
    id: "fisica", nombre: "Física", grupo: "Ciencias Básicas", color: "#06B6D4",
    cursos: [
      { cod: "FI1101", nom: "Física General I" },
      { cod: "FI1102", nom: "Física General II" },
      { cod: "FI2103", nom: "Física General III" },
      { cod: "FI2104", nom: "Física General IV" },
      { cod: "FI1105", nom: "Física para Biotecnología" }],
  },
  {
    id: "quimica", nombre: "Química y Biología", grupo: "Ciencias Básicas", color: "#67E8F9",
    cursos: [
      { cod: "QU1106", nom: "Química Básica I" },
      { cod: "QU1107", nom: "Química Básica II" },
      { cod: "QU1902", nom: "Fundamentos de Química" },
      { cod: "QU2403", nom: "Química Orgánica" },
      { cod: "QU2407", nom: "Fundamentos de Química Orgánica" },
      { cod: "QU2409", nom: "Química Orgánica y Bioquímica" },
      { cod: "QU2604", nom: "Química Ambiental y Analítica" },
      { cod: "BI1101", nom: "Biología General" },
      { cod: "BI2301", nom: "Genética" }],
  },
  {
    /* Ingeniería en Computación son las siglas IC y CA. Los CE, que antes
       vivían acá dentro, son otra carrera —Ingeniería en Computadores— y
       hoy tienen su propia área en datos/cursosTEC.js. El id se queda en
       "compu" a propósito: es el de siempre y no hay razón para romperlo. */
    id: "compu", nombre: "Ingeniería en Computación", grupo: "Computación y TI", color: "#2DD4BF",
    cursos: [
      { cod: "IC1400", nom: "Fundamentos de Organización de Computadoras" },
      { cod: "IC1802", nom: "Introducción a la Programación" },
      { cod: "IC2001", nom: "Estructuras de Datos" },
      { cod: "IC2101", nom: "Programación Orientada a Objetos" },
      { cod: "IC3002", nom: "Análisis de Algoritmos" },
      { cod: "IC3101", nom: "Arquitectura de Computadores" },
      { cod: "CA2125", nom: "Elementos de Computación" }],
  },
  /* Idiomas: cada idioma es su propia área, igual que cada grado lo es para
     Colegios — así el buscador ya sabe agrupar por idioma sin tocar nada
     más. Los cursos van sin código, como antes: basta el nombre con su
     nivel para identificarlos. */
  {
    id: "ingles", nombre: "Inglés", color: "#0D9488",
    cursos: [
      { nom: "Diagnóstico Nivel Inglés" },
      { nom: "Inglés Básico" },
      { nom: "Inglés Intermedio" },
      { nom: "Inglés Avanzado" },
    ],
  },
  {
    id: "hebreo", nombre: "Hebreo", color: "#5EEAD4",
    cursos: [
      { nom: "Hebreo Básico" },
      { nom: "Hebreo Intermedio" },
      { nom: "Hebreo Avanzado" },
    ],
  },
  {
    id: "portugues", nombre: "Portugués", color: "#99F6E4",
    cursos: [
      { nom: "Portugués Básico" },
      { nom: "Portugués Intermedio" },
      { nom: "Portugués Avanzado" },
    ],
  },
  /* Colegios: cada nivel es su propia área, igual que Matemática o Física lo
     son para el Tec — así el buscador ya sabe agrupar por nivel sin tocar
     nada más. Décimo y Undécimo van por año; sétimo, octavo y noveno van
     juntos en un solo "Tercer Ciclo" (ver el comentario de col789). Las
     materias van sin código, como los idiomas, pero el nivel se suma al
     nombre porque una misma materia (p. ej. Matemática) se repite en varios
     niveles: sin el nivel en el nombre, el catálogo (CURSO, más abajo)
     confundiría la Matemática de Undécimo con la de Décimo al indexar por
     nombre.

     Todos los niveles comparten el mismo verde-agua de Idiomas (#0D9488), a
     propósito y sin excepción: antes cada grado tenía su propio tono de
     azul, pero el pedido fue unificar el acento de Colegios (barra, borde,
     glow y foco) con el de Idiomas en vez de tener una escala propia. */
  {
    id: "col11", nombre: "Undécimo", color: "#0D9488",
    cursos: [
      { nom: "Matemática · Undécimo" },
      { nom: "Física · Undécimo" },
      { nom: "Química · Undécimo" },
      { nom: "Biología · Undécimo" }],
  },
  {
    id: "col10", nombre: "Décimo", color: "#0D9488",
    cursos: [
      { nom: "Matemática · Décimo" },
      { nom: "Física · Décimo" },
      { nom: "Química · Décimo" },
      { nom: "Biología · Décimo" }],
  },
  /* Tercer ciclo va unificado: un área con un solo curso que cubre sétimo,
     octavo y noveno juntos. Antes eran tres áreas (col7/col8/col9) con su
     Matemática y su Ciencias cada una; Ciencias se retiró del catálogo y
     los tres niveles de Matemática se juntaron en uno, porque el temario
     del ciclo es continuo y quien lo da, lo da entero — pedir tres
     registros para lo mismo solo partía la oferta en tres tarjetas más
     flacas. Décimo y Undécimo siguen separados: ahí sí cada año tiene su
     programa y sus cuatro materias. */
  {
    id: "col789", nombre: "Tercer Ciclo", color: "#0D9488",
    cursos: [
      { nom: "Matemática · 7.°, 8.° y 9.°" }],
  },
  /* Preparación Examen Admisión: a diferencia de Colegios/Idiomas, acá no
     hay un tercer nivel de cursos por área — cada área ES el curso (su
     único curso lleva el mismo nombre que ella), así el buscador la muestra
     como categoría plana: Todas / Razonamiento Matemático / Razonamiento
     Verbal, sin fila de cursos debajo. Todas comparten el
     mismo verde-agua de Idiomas (#0D9488). */
  {
    id: "examadm-mate", nombre: "Razonamiento Matemático", color: "#0D9488",
    cursos: [{ nom: "Razonamiento Matemático" }],
  },
  {
    id: "examadm-verbal", nombre: "Razonamiento Verbal", color: "#0D9488",
    cursos: [{ nom: "Razonamiento Verbal" }],
  },
  /* El resto del catálogo del Tec: 8 carreras más — Ingeniería en
     Computadores, Administración de Tecnologías de Información,
     Electromecánica, Electrónica, Mecatrónica, Materiales, Ingeniería
     Física y Administración de Empresas. Viven en su propio archivo por lo
     mismo que las de la UCR: son un catálogo largo y de mantenimiento
     aparte, y mezclarlo acá enterraría el de Idiomas, Colegios y Software.
     Todas llevan el turquesa del Tec; las cuatro de arriba conservan cada
     una su tono histórico, que es el que le acompaña al tutor por toda la
     interfaz y no tiene sentido cambiarle a nadie a estas alturas. */
  ...AREAS_TEC,
  /* Software: cada herramienta es su propia área, sin código — como en
     Idiomas, donde un idioma allá es un programa acá, el nombre hace de
     identificador.

     Solo Excel se divide en niveles: es la herramienta donde "básico" y
     "avanzado" son de verdad dos tutorías distintas (formato y fórmulas
     contra tablas dinámicas y macros), y quien la busca ya sabe cuál de las
     dos necesita. En las demás el área abre directo a sus tutores, sin
     pedir que se elija un nivel primero — ver el comentario del bloque de
     cursos en CatalogoTutores.jsx. Cuando hay niveles van pegados al nombre
     ("Excel · Avanzado") por la misma razón que en Colegios: el catálogo
     CURSO (más abajo) indexa por nombre, así que un "Básico" pelado
     chocaría con el de cualquier otra herramienta que se divida mañana.

     Todas comparten el cian #22D3EE, igual que los grados de Colegios
     comparten su verde-agua: el acento distingue la institución, no la
     herramienta.

     A diferencia del resto, acá no hay nota de curso que mostrar: quien se
     registra declara su nivel de conocimiento —Básico, Intermedio o
     Avanzado, sea cual sea la herramienta— y lo respalda con un certificado
     o una constancia (ver `verificacion` en INSTITUCIONES, más abajo). Eso
     mide a quien enseña y es independiente de que el curso tenga niveles o
     no: el nivel del curso dice qué se enseña, el de quien enseña, cuánto
     sabe.

     `grupo` junta las herramientas parecidas (igual que en la UCR agrupa las
     escuelas por área académica, ver datos/cursosUCR.js). El buscador público
     no lo usa —sus áreas ya van ordenadas por grupo en la cuadrícula— pero el
     <select> del panel del tutor sí, para no dejar diecisiete opciones
     sueltas una detrás de otra. */
  {
    id: "sw-excel", nombre: "Excel", grupo: "Ofimática y datos", color: "#22D3EE",
    cursos: [
      { nom: "Excel · Básico" },
      { nom: "Excel · Intermedio" },
      { nom: "Excel · Avanzado" },
    ],
  },
  {
    id: "sw-powerbi", nombre: "Power BI", grupo: "Ofimática y datos", color: "#22D3EE",
    cursos: [{ nom: "Power BI" }],
  },
  {
    id: "sw-sql", nombre: "SQL", grupo: "Ofimática y datos", color: "#22D3EE",
    cursos: [{ nom: "SQL" }],
  },
  {
    id: "sw-r", nombre: "R", grupo: "Ofimática y datos", color: "#22D3EE",
    cursos: [{ nom: "R" }],
  },
  {
    id: "sw-spss", nombre: "SPSS", grupo: "Ofimática y datos", color: "#22D3EE",
    cursos: [{ nom: "SPSS" }],
  },
  {
    id: "sw-python", nombre: "Python", grupo: "Programación", color: "#22D3EE",
    cursos: [{ nom: "Python" }],
  },
  {
    id: "sw-java", nombre: "Java", grupo: "Programación", color: "#22D3EE",
    cursos: [{ nom: "Java" }],
  },
  {
    id: "sw-c", nombre: "C y C++", grupo: "Programación", color: "#22D3EE",
    cursos: [{ nom: "C y C++" }],
  },
  {
    id: "sw-javascript", nombre: "JavaScript", grupo: "Programación", color: "#22D3EE",
    cursos: [{ nom: "JavaScript" }],
  },
  {
    id: "sw-html", nombre: "HTML y CSS", grupo: "Programación", color: "#22D3EE",
    cursos: [{ nom: "HTML y CSS" }],
  },
  {
    id: "sw-autocad", nombre: "AutoCAD", grupo: "Ingeniería y CAD", color: "#22D3EE",
    cursos: [{ nom: "AutoCAD" }],
  },
  {
    id: "sw-solidworks", nombre: "SolidWorks", grupo: "Ingeniería y CAD", color: "#22D3EE",
    cursos: [{ nom: "SolidWorks" }],
  },
  {
    id: "sw-fusion", nombre: "Fusion 360", grupo: "Ingeniería y CAD", color: "#22D3EE",
    cursos: [{ nom: "Fusion 360" }],
  },
  {
    id: "sw-inventor", nombre: "Inventor", grupo: "Ingeniería y CAD", color: "#22D3EE",
    cursos: [{ nom: "Inventor" }],
  },
  {
    id: "sw-sketchup", nombre: "SketchUp", grupo: "Ingeniería y CAD", color: "#22D3EE",
    cursos: [{ nom: "SketchUp" }],
  },
  {
    id: "sw-matlab", nombre: "MATLAB y Simulink", grupo: "Ingeniería y CAD", color: "#22D3EE",
    cursos: [{ nom: "MATLAB y Simulink" }],
  },
  {
    id: "sw-illustrator", nombre: "Illustrator", grupo: "Diseño", color: "#22D3EE",
    cursos: [{ nom: "Illustrator" }],
  },
  /* UCR: 19 áreas (una por escuela o carrera) con los ~735 cursos de grado
     tutorables de la Guía de Cursos y Horarios oficial. Viven en su propio archivo
     porque son datos generados, no escritos a mano como los de arriba —
     mezclarlos acá enterraría el catálogo del Tec, de Idiomas y de Colegios
     bajo dos mil líneas. Ver datos/cursosUCR.js para el origen y el alcance. */
  ...AREAS_UCR];

/* Instituciones: el nivel superior del buscador, arriba de las áreas.
   Cada institución agrupa un subconjunto de AREAS por su id. El Tec agrupa
   las materias técnicas (tutorías de refuerzo por curso); Idiomas agrupa un
   idioma por área, igual que el Tec agrupa una materia por área — es
   aprendizaje continuo, no refuerzo puntual de un curso, pero la estructura
   de sub-áreas es la misma; Colegios agrupa un nivel (grado) por área; la
   UCR agrupa una escuela por área (Matemática, Ingeniería Civil, Medicina…),
   que es la misma idea del Tec pero a la escala del catálogo entero de la
   universidad; Software agrupa una herramienta por área, con sus niveles
   dentro cuando los tiene (hoy solo Excel), igual que Idiomas. Para sumar otra (UNA, UNED, ...) alcanza con
   agregar un bloque acá con sus propias AREAS — no hace falta tocar el
   buscador.

   `corto` es opcional: es el nombre que usan los botones angostos del
   formulario de registro, donde "Universidad de Costa Rica" no cabe.

   `verificacion` dice con qué respalda su capacidad quien quiere dar esas
   tutorías, y es opcional: sin él se pide la nota del curso (80–100) con la
   captura del expediente, que es el caso de las universidades. Las
   instituciones que no tienen tal nota declaran su escala — "cefr" en
   Idiomas, "software" en Software, "examadm" en Preparación Examen
   Admisión, donde lo que respalda a quien prepara el examen es la nota que
   él mismo sacó (0–900), no una nota de curso; y "colegio", que no pide
   respaldo del todo: para dar tutorías de colegio no se solicita ni nota ni
   comprobante, basta el perfil, que un administrador revisa igual antes de
   publicarlo. Las escalas y su copia viven en lib/horarios.js
   (ESCALAS_NIVEL); acá solo va cuál le toca a cada una. */
export const INSTITUCIONES = [
  {
    id: "tec", nombre: "Tecnológico de Costa Rica", corto: "TEC",
    desc: "Tutorías de refuerzo por curso", color: "#14B8A6",
    areas: ["mate", "fisica", "quimica", "compu", ...AREAS_TEC_IDS],
  },
  {
    id: "idiomas", nombre: "Idiomas",
    desc: "Aprendizaje continuo, no un curso puntual", color: "#0D9488",
    verificacion: "cefr",
    areas: ["ingles", "hebreo", "portugues"],
  },
  {
    id: "colegios", nombre: "Colegios",
    desc: "Tutorías de refuerzo por nivel", color: "#0D9488",
    verificacion: "colegio",
    areas: ["col11", "col10", "col789"],
  },
  {
    id: "examadm", nombre: "Preparación Examen Admisión",
    desc: "Preparación para exámenes de admisión universitaria", color: "#0D9488",
    verificacion: "examadm",
    areas: ["examadm-mate", "examadm-verbal"],
  },
  {
    id: "ucr", nombre: "Universidad de Costa Rica", corto: "UCR",
    desc: "Tutorías de refuerzo por curso", color: "#06B6D4",
    areas: AREAS_UCR_IDS,
  },
  {
    id: "software", nombre: "Software",
    desc: "Herramientas y programas de uso profesional", color: "#22D3EE",
    verificacion: "software",
    areas: [
      "sw-excel", "sw-powerbi", "sw-sql", "sw-r", "sw-spss",
      "sw-python", "sw-java", "sw-c", "sw-javascript", "sw-html",
      "sw-autocad", "sw-solidworks", "sw-fusion", "sw-inventor", "sw-sketchup",
      "sw-matlab", "sw-illustrator"],
  }];

/* A qué institución pertenece cada área. Desde que hay dos universidades, el
   nombre del área ya no alcanza para ubicar un curso: "Matemática" y "Física"
   existen igual en el Tec que en la UCR, así que las sugerencias del buscador
   muestran también la institución (ver CatalogoTutores.jsx y BuscadorCursos.jsx). */
const INST_DE_AREA = {};
INSTITUCIONES.forEach((i) => i.areas.forEach((a) => { INST_DE_AREA[a] = i.nombre; }));

/* Y con qué se verifica a quien la quiere enseñar (ver `verificacion` arriba). */
const VERIF_DE_AREA = {};
INSTITUCIONES.forEach((i) => i.areas.forEach((a) => { VERIF_DE_AREA[a] = i.verificacion; }));

/* Un curso puede venir con código (ciencias) o solo con nombre (idiomas).
   Cuando no hay código, el nombre hace de identificador.                    */
export const CURSO = {};
AREAS.forEach((a) => a.cursos.forEach((c) => {
  const clave = c.cod || c.nom;
  c.sinCodigo = !c.cod;      // los idiomas van sin código
  c.cod = clave;             // el identificador queda también en el catálogo del área
  CURSO[clave] = {
    ...c, area: a.id, color: a.color, areaNom: a.nombre, instNom: INST_DE_AREA[a.id] || "",
  };
}));

/* Qué se le pide a quien quiere dar tutorías de este curso: el id de una
   escala de ESCALAS_NIVEL (lib/horarios.js) si su institución declara una, o
   undefined si va por la nota del curso de siempre — escalaDeCurso() de
   lib/horarios.js resuelve ese undefined a la escala "nota". Un curso
   digitado que no está en el catálogo cae en "Por Asignar", que no declara
   escala: nota. */
export const verificacionDe = (cod) => VERIF_DE_AREA[infoCurso(cod).area];

/* Info de un curso. Un curso digitado que no está en el catálogo cae en
   "Por Asignar": ya no es un área del buscador —no hay cuadro que abrir— pero
   sigue siendo el nombre y el gris con que se muestra donde aparezca. */
export const infoCurso = (c) => CURSO[c]
  || { cod: c, nom: c, color: "#64748B", sinCodigo: true, area: "porasignar", areaNom: "Por Asignar" };

